import React from 'react'
import NumberFormat from 'react-number-format'
import {TextField} from '@material-ui/core'
import {defaultInputStyle} from '../../utils'

export default function PhoneNumberInput(props){

    const { tProps, ...wrapperProps } = props
    return(
        <div
            {...wrapperProps}
            style={{width: '100%', ...wrapperProps.style}}
        >
            <NumberFormat 
                {...tProps}
                type='tel'
                format="(###) ###-####" 
                allowEmptyFormatting 
                mask="_"
                customInput={TextField}
                style={defaultInputStyle}
            />

        </div>
    )
}